import React, { useState } from 'react'
import Layout from '../Layouts/Layout'
import TopSection from '../Common/TopSection'
import AppointmentForm from './AppointmentForm'
import ModalLayout from '../Modals/ModalLayout'
import NewAppraisalModal from '../Modals/NewAppraisalModal'
import ModalLayoutNew from '../Modals/ModalLayoutNew'
const accordionItems = [
    {
        title: "Appointments",
        content: (index) => <AppointmentForm index={index} />
    },
    {
        title: "After lead submission with no response",
        content: (index) => <AppointmentForm index={index} />
    },
    {
        title: "After sale",
        content: (index) => <AppointmentForm index={index} />
    },
    {
        title: "After submission with $100 offer",
        content: (index) => <AppointmentForm index={index} />
    },
    {
        title: "Some Rule Name 1",
        content: (index) => <AppointmentForm index={index} />
    },
    {
        title: "Some Rule Name 2",
        content: (index) => <AppointmentForm index={index} />
    }
]
const AutoPilot = () => {
    return (
        <>
            <Layout>
                <section className='main-block py-4'>
                    <div className='container-fluid'>
                        <div className='gray-box'>
                            <div className='d-flex align-items-center justify-content-between mb-3'>
                                <div className='lg-title text-uppercase font-26'>Communication Autopilot</div>
                                <div>
                                    <button type='button' className='blue-transparent-btn text-uppercase'>Add New Rule</button>
                                </div>
                            </div>
                            <div className="accordion autopilot-accordion" id="accordionExample">
                                {accordionItems.map((item, index) => (
                                    <div className="accordion-item" key={index}>
                                        <h2 className="accordion-header">
                                            <button
                                                className="accordion-button"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target={`#collapse${index}`}
                                                aria-expanded={index === 0 ? "true" : "false"}
                                                aria-controls={`collapse${index}`}
                                            >
                                                {item.title}
                                            </button>
                                        </h2>
                                        <div id={`collapse${index}`} className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}>
                                            <div className="accordion-body">
                                                {item.content(index)}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>
            </Layout>
        </>
    )
}

export default AutoPilot